import { HimuraInject } from 'himura';
import { DataDelegate } from '../data.delegate';
import { IShowing, IShowingCreate, IAgentMatch, IShowingDetail, IShowingPostForm } from '../../../models/showing';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { AxiosPromise } from '../../../utils/axios.promise';

@HimuraInject.NamedService('ShowingsRestfulDelegate')
export class ShowingsRestfulDelegate extends DataDelegate {

    public commonConfigs: CommonConfig = new CommonConfig();

    constructor() {
        super('ShowingsRestfulDelegate');
    }

    public async getShowingById(id: string) {
        const apiHost: string = this.commonConfigs.apiHost;
        const fetched = await AxiosPromise.get(`${apiHost}/showing/getById?id=${id}`);
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            return fetched;
        } else {
            return 0;
        }
    }

    public async createShowing(data: IShowingPostForm) {
        const apiHost: string = this.commonConfigs.apiHost;
        switch (data.smsType) {
            case 'showing_request': {
                const formData = new FormData();
                formData.set('fromAgentId', data.fromAgentId!.toString());
                formData.set('smsContent', data.smsContent!.toString());
                formData.set('callback', data.callback!.toString());
                formData.set('smsType', data.smsType!.toString());
                formData.set('listingId', data.listingId!.toString());
                formData.set('showingTime', data.showingTime!.toString());
                formData.set('showingDate', data.showingDate!.toString());
                formData.set('operator', data.operator!.toString());
                formData.set('operatorId', data.operatorId!.toString());
                const fetched = await AxiosPromise.postForm(`${apiHost}/showing/creation`, formData);
                if (T_T.simpleDetect(fetched) && fetched.data.errorCode === 200) {
                    return 1;
                } else {
                    return 0;
                }
                break;
            }
            case 'other_message': {
                const body = {
                    toAgentId: data.toAgentId!,
                    smsContent: data.smsContent!,
                    operator: data.operator!,
                    operatorId: data.operatorId!,
                    callback: data.callback!,
                    fromAgentId: data.fromAgentId,
                    smsType: data.smsType!
                };
                const formData = new FormData();
                formData.set('toAgentId', data.toAgentId!.toString());
                formData.set('smsContent', data.smsContent!.toString());
                formData.set('operator', data.operator!.toString());
                formData.set('operatorId', data.operatorId!.toString());
                formData.set('callback', data.callback!.toString());
                formData.set('fromAgentId', data.fromAgentId!.toString());
                formData.set('smsType', data.smsType!.toString());
                const fetched = await AxiosPromise.postForm(`${apiHost}/showing/creation`, formData);
                if (T_T.simpleDetect(fetched) && fetched.data.errorCode === 200) {
                    return 1;
                } else {
                    return 0;
                }
                break;
            }
        }
    }

    public async updateShowing(id: string, newData: IShowing) {
        const apiHost: string = this.commonConfigs.apiHost;
        const formData = new FormData();
        formData.set('id', newData.id!.toString());
        // formData.set('xStatus', newData.status!.toString());
        formData.set('xShowingDate', newData.visit_date!.toString());
        const fetched = await AxiosPromise.postForm(`${apiHost}/showing/update`, formData);
        if (T_T.simpleDetect(fetched) && fetched.data.errorCode === 200) {
            return 1;
        } else {
            return 0;
        }
    }

    public async confirmShowing(ids: string[]) {
        const apiHost: string = this.commonConfigs.apiHost;
        for (let i = 0; i < ids.length; i++) {
            const formData = new FormData();
            formData.set('id', ids[i]!.toString());
            formData.set('xStatus', 'Confirmed');
            await AxiosPromise.postForm(`${apiHost}/showing/update`, formData);
        }
        return 1;
    }

    public async cancelShowing(ids: string[]) {
        const apiHost: string = this.commonConfigs.apiHost;
        for (let i = 0; i < ids.length; i++) {
            const formData = new FormData();
            formData.set('id', ids[i]!.toString());
            formData.set('xStatus', 'Cancelled');
            await AxiosPromise.postForm(`${apiHost}/showing/update`, formData);
        }
        return 1;
    }

    public async getHistory(id: string) {
        const apiHost: string = this.commonConfigs.apiHost;
        const fetched = await AxiosPromise.get(`${apiHost}/showing/opt/logs?id=${id}`);
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            return fetched;
        } else {
            return 0;
        }
    }
}
